export const S3_IMAGES_URL = 'https://static.solartrip.com/images/referral/';
export const S3_MP4_URL = 'https://static.solartrip.com/mp4/referral/';
